import React from 'react';
import './hero.scss';
import { Container, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import HeroDialogContent from '../dialogs/dialog_hero';

const Hero = () => {
  return (
    <div className="App_hero">
      <Container maxWidth="md">
        <Typography variant="h2">
          Risk-managed Staking in the Sea of DeFi&nbsp;Insurance{' '}
        </Typography>
        <p>
          iTrust.finance creates mutually beneficial relationships between
          stakers and insurance protocols by maximising rewards and growing
          cover capacity for all participants of the DAO, and the wider
          DeFi&nbsp;community.
        </p>

        <Button
          className="App-button-a"
          rel="noreferrer"
          href="https://app.itrust.finance/"
        >
          iTrust App
        </Button>

        <HeroDialogContent />
      </Container>
    </div>
  );
};

export default Hero;
